import "styles/Home.css";

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flex, Tooltip, theme } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { StringParam } from "use-query-params";

import { useProduct } from "hooks/useProduct";
import { encodeQueryParamsWithProducts } from "functions/queryParamFuncs";
import CardTitle from "components/Common/CardTitle";
import ItemInfoCard from "components/ItemDetails/ItemInfoCard";
import UnitMapCard from "components/Home/UnitMapCard";
import useFetch from "hooks/useFetch";

const HomePage = () => {
  const {
    token: { padding },
  } = theme.useToken();
  const { selectedProductIds } = useProduct();
  const { responseData: latestItemUuidResponseData, doFetch: getLatestItemUuid } = useFetch(
    "/items/getLatestItemUuid",
    "GET",
    [],
    false
  );
  const [intervalId, setIntervalId] = useState();

  const itemUuid = latestItemUuidResponseData.data ?? undefined

  const fetchLatestItemUuid= () => {
    getLatestItemUuid({
      products: selectedProductIds
    });
  };

  const itemDetailsLink = itemUuid
    ? `/items/details?${encodeQueryParamsWithProducts(
        selectedProductIds,
        { itemUuid: StringParam },
        { item: itemUuid }
      )}`
    : null;
  

  useEffect(()=>{
    if(intervalId !== undefined){
      clearInterval(intervalId)
      setIntervalId(undefined)
    }
    if(selectedProductIds.length !== 0){
      fetchLatestItemUuid()
    }
  },[selectedProductIds])

  useEffect(()=>{
    if(selectedProductIds.length !== 0 && itemUuid !== undefined && intervalId === undefined) {
      setIntervalId(
        setInterval(
          ()=>{fetchLatestItemUuid();}
          ,100
        ) 
      )
    }

    return() => {
      if(intervalId !== undefined){
        clearInterval(intervalId)
        setIntervalId(undefined)
      }
    };
  },[itemUuid, intervalId])
      
  return (
    <>
      <Flex align="top" gap="small" style={{ paddingLeft: padding }}>
        <CardTitle
          title="Last Processing Item"
          size="xl"
          icon={
            <Tooltip title="View Item Details">
              <Link to={itemDetailsLink} target="_blank">
                <ExportOutlined />
              </Link>
            </Tooltip>
          }
        />
      </Flex>
      <Flex vertical={true} gap="small" style={{height: "94%"}}>
        <ItemInfoCard key={"item_info_" + itemUuid} itemUuid={itemUuid} />
        <UnitMapCard key={"unit_map_" + itemUuid} itemUuid={itemUuid} />
      </Flex>
    </>
  );
};

export default HomePage;
